import React, { ReactNode } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import RootState from 'Store/Root';
import {
  isAccountLoadingSelector,
  authLinksSelector
} from 'Store/User/Selectors';

import { basketItemCountSelector } from 'Store/Basket/Selectors/BasketItem';

import * as Props from './Props';

import { Header } from './Header';

const HeaderContainer: React.StatelessComponent<Props.ContainerProps> = (props) => (
  <Header {...props} />
);

export default withRouter<{ children?: ReactNode; }>(
  connect<Props.MapStateToProps, {}, Props.ExposedProps>(
    (state: RootState, ownProps: Props.ExposedProps): Props.MapStateToProps => {
      return {
        loading: isAccountLoadingSelector(state),
        authLinks: authLinksSelector(state, ownProps),
        basketCount: basketItemCountSelector(state)
      };
    }
  )(HeaderContainer)
);
